import type { TFunction } from 'i18next';
import { AdKind } from '@/api/types/common.types';
import { BulkPromotionServiceType } from '@/features/Profile/sections/MyAds/api';
import { promotions } from '@/components/Ad/Promotions/Promotions.constants';

const AD_KIND_BY_SERVICE_TYPE: Record<BulkPromotionServiceType, AdKind> = {
  [BulkPromotionServiceType.BUMP]: AdKind.Bumped,
  [BulkPromotionServiceType.VIP]: AdKind.Vipped,
  [BulkPromotionServiceType.FEATURE]: AdKind.Premium,
};

export function getBulkPromotionPresentation(
  serviceType: BulkPromotionServiceType,
  t: TFunction
) {
  const adKind = AD_KIND_BY_SERVICE_TYPE[serviceType];

  return promotions(t, 0, 0, 0, true).find(
    promotion => promotion.type === adKind
  );
}
